import { ADMIN_TYPES } from "services/types";
import { init, success, finish, error } from "services/common";
import { message } from "antd";
import { RotoService } from "./api";

const rotoService = new RotoService();

// export const actionForGetRotoListing = () => {
//   return async (dispatch) => {
//     dispatch(init(ADMIN_TYPES.ROTO_TYPE_LISTING));
//     const response = await rotoService.getRotoListing();
//     dispatch(finish(ADMIN_TYPES.ROTO_TYPE_LISTING));
//     if (response.isSuccess) {
//       dispatch(success(ADMIN_TYPES.ROTO_TYPE_LISTING, response.data));
//     } else if (!response.isSuccess) {
//       dispatch(error(response.errorMessage));
//     }
//   };
// };

export const getRotoPaginationListNew = (q, loadMore) => {
  return async (dispatch) => {
    dispatch(init(ADMIN_TYPES.ROTO_TYPE_LISTING));
    const response = await rotoService.getRotoPaginationListNew(q);
    if (response?.cancelApi === false) return;
    if (response.isSuccess) {
      if (loadMore) {
        dispatch(
          success(ADMIN_TYPES.ROTO_TYPE_LISTING_LOAD_MORE, response.data)
        );
      } else {
        dispatch(success(ADMIN_TYPES.ROTO_TYPE_LISTING, response.data));
      }
    } else if (!response.isSuccess) {
      dispatch(error(response.errorMessage));
    }
    dispatch(finish(ADMIN_TYPES.ROTO_TYPE_LISTING));
  };
};

export const actionForAddRoto = (body) => {
  return async (dispatch) => {
    console.log("body ", body);
    dispatch(init(ADMIN_TYPES.ROTO_TYPE_ADD));
    const response = await rotoService.createRoto(body);
    dispatch(finish(ADMIN_TYPES.ROTO_TYPE_ADD));
    if (response.isSuccess) {
      dispatch(success(ADMIN_TYPES.ROTO_TYPE_ADD, response.data));
      message.success("Added Roto Video");
    } else if (!response.isSuccess) {
      dispatch(error(response.errorMessage));
    }
  };
};

export const actionForUpdateRoto = (body) => {
  return async (dispatch) => {
    dispatch(init(ADMIN_TYPES.ROTO_TYPE_UPDATE));
    const response = await rotoService.updateRoto(body);
    dispatch(finish(ADMIN_TYPES.ROTO_TYPE_UPDATE));
    if (response.isSuccess) {
      dispatch(success(ADMIN_TYPES.ROTO_TYPE_UPDATE, response.data));
      // console.log("ACTTION Update: ", response.data);
      message.success("Updated Roto Video");
    } else if (!response.isSuccess) {
      dispatch(error(response.errorMessage));
    }
  };
};
